import { z } from "zod";

export const AvailableSenderSchema = z.object({
	userId: z.number(),
	name: z.string(),
	type: z.string(),
	emailAddress: z.string().optional(),
	emailId: z.number().optional(),
	isInCampaign: z.boolean(),
});

export const OriginSenderSchema = z.object({
	name: z.string(),
	type: z.enum(["email", "linkedin"]),
	emailAddress: z.string().optional(),
});

export const CampaignPendingSchema = z.object({
	campaignId: z.string(),
	campaignName: z.string(),
	listId: z.number(),
	listName: z.string(),
	pendingCount: z.number(),
	availableSenders: z.array(AvailableSenderSchema),
	originSender: OriginSenderSchema.optional(),
});

export const PendingSchedulesBySenderResponseSchema = z.object({
	totalCount: z.number(),
	campaigns: z.array(CampaignPendingSchema),
});

export const MigrationLevelEnum = z.enum(["safe", "silent", "forced"]);
export type MigrationLevel = z.infer<typeof MigrationLevelEnum>;

export const CampaignActionSchema = z.object({
	campaignId: z.string(),
	listId: z.number(),
	action: z.enum(["cancel", "reassign", "skip"]),
	oldUserId: z.number().optional(),
	oldEmailId: z.number().optional(),
	newEmailId: z.number().optional(),
	newUserId: z.number().optional(),
	addToCampaign: z.boolean().optional(),
	migrationLevel: MigrationLevelEnum.default("safe"),
});

export const ReassignSchedulesResponseSchema = z.object({
	success: z.boolean(),
	processedCount: z.number(),
});

export type AvailableSender = z.infer<typeof AvailableSenderSchema>;
export type CampaignPending = z.infer<typeof CampaignPendingSchema>;
export type PendingSchedulesBySenderResponse = z.infer<
	typeof PendingSchedulesBySenderResponseSchema
>;
export type CampaignAction = z.infer<typeof CampaignActionSchema>;
export type ReassignSchedulesResponse = z.infer<typeof ReassignSchedulesResponseSchema>;
